import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BackendApiService } from '../../../../../app/services/backend-api.service';
import { BaseUrlConstantsService } from '../../../../../app/services/base-url-constants.service';
import { ConvertDatetimePipe } from '../../../../../app/convert-datetime.pipe';

export interface Service {
  asset_id: string | number;
  inventory_id: string | number;
  last_service_date: string | null;
  next_service_date: string | null;
  last_service_performed: string | null;
  service_category: string | null;
  service_detail: string | null;
  service_performed_by: string | null;
  user_id: string | number;
}

@Component({
  selector: 'app-service-status-settings',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './service-status-settings.component.html',
  styleUrl: './service-status-settings.component.scss'
})
export class ServiceStatusSettingsComponent implements OnInit {
  form: FormGroup;
  loading = false;
  updating = false;
  originalData: Service | null = null;
  today = new Date();

  serviceCategories = [
    'Planned Repair/Service',
    'Unplanned Repair/Service',
    'In Service',
  ];

  serviceTypes = [
    'Electrical Unbalance Corrected',
    'Machine DE Bearing repaired',
    'Machine NDE Bearing repaired',
    'Stator Winding repaired',
    'Soft Foot corrected',
    'Bent Rotor Repaired',
    'Journal Bearing Repaired',
    'Machine Looseness corrected',
    'Others',
  ];

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ServiceStatusSettingsComponent>,
    private backendService: BackendApiService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    if (this.data && this.data.serviceData) {
      this.originalData = this.data.serviceData;
      this.initForm(this.data.serviceData);
    }
    else {
      this.initForm({});
    }
  }

  initForm(data: any) {
    this.form = this.fb.group({
      last_service_date: [data.last_service_date ? (data.last_service_date) : null],
      next_service_date: [data.next_service_date ? (data.next_service_date) : null],
      service_category: [data.service_category || ""],
      last_service_performed: [data.last_service_performed || ""],
      service_performed_by: [data.service_performed_by || ""],
      service_detail: [data.service_detail || ""],
    });
  }

  get hasChanges(): boolean {
    return this.form.dirty;
  }

  async handleUpdate() {
    if (this.form.invalid) return;
    this.updating = true;

    try {
      const formVal = this.form.value;
      console.log(formVal)

      const requestBody = {
        asset_id: String(this.data.assetId),
        inventory_id: String(this.data.inventoryId || this.originalData?.inventory_id),
        last_service_date: formVal.last_service_date,
        next_service_date: formVal.next_service_date,

        last_service_performed: formVal.last_service_performed || null,
        service_category: formVal.service_category || null,
        service_detail: formVal.service_detail || null,
        service_performed_by: formVal.service_performed_by || null,
        user_id: String(this.data.userId),
      };

      const apiUrl = `${BaseUrlConstantsService.BASE_ASSET_SERVICE}/${this.data.serviceData.id}/${this.data.macAddress}`;
      const response: any = await this.backendService.putData(apiUrl, requestBody);

      if (response?.data?.status === 'success') {
        this.dialogRef.close(true);
      } else {
        console.error("Update failed", response);
      }

    } catch (error) {
      console.error(error);
    } finally {
      this.updating = false;
    }
  }

  close() {
    this.dialogRef.close();
  }
}
